import MatchPhaseProvider from '../../sportGlossary/matchPhaseProvider';
export function getPeriodInfo(match, gridLocalization) {
    var sportId = match.get("realSportId");
    var periodId = match.getIn(["period", "id"]);
    var matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);
    return {
        matchMinute: match.getIn(["period", "minute"]),
        period: gridLocalization.getPeriodName(sportId, periodId),
        matchPhase: matchPhase
    };
}



// WEBPACK FOOTER //
// ./src/components/grid/event/statistics/utils.js